import React, { useCallback, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";

import * as commonData from "../../../Common";
import Loading from "../../UI/Loading";

const AttributePropertiseManagement = ({
  attributes,
  attributePropertise,
  loading,
}) => {
  const param = useParams();
  const api = commonData.commonData().apiUrl;
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    setRowData(attributes);
    setColumnDefs(attributePropertise);
  }, [attributes, attributePropertise]);

  const onChangeHandler = useCallback(
    async (evt, field, key, attribute_set_key) => {
      const { name, value } = evt.target;

      const datas = [...rowData];

      const index = datas.findIndex((item) => item.field === field);
      const rowNode = gridRef.current.api.getRowNode(index); // Get row node by id
      let newobj = datas[index];

      if (rowNode) {
        rowNode.setDataValue([key], !rowNode?.data[key]); // Update the age cell value
      }

      newobj = {
        ...newobj,
        [key]: !newobj[key],
      };
      datas[index] = newobj;
      // setRowData(datas);

      const response = await fetch(`${api}attribute/update`, {
        method: "POST",
        body: JSON.stringify({
          app_token: commonData.commonData().appToken,
          user_uuid: commonData.commonData().userId,
          attribute_set_key: attribute_set_key,
          attribute_key: field,
          attribute_properties: {
            [key]: newobj[key],
          },
        }),
      });

      const rdata = await response.json();
    },
    [attributes, rowData]
  );

  const onRowDragStart = (evt) => {};

  const onRowDragEnd = (evt) => {};

  const CheckboxRenderer = (evt) => {
    const { colDef, data } = evt;
    return (
      <input
        type="checkbox"
        id=""
        checked={data[colDef.field]}
        name={colDef.field}
        value={data[colDef.field]}
        onChange={(evt) =>
          onChangeHandler(evt, data.field, colDef.field, data.attribute_set_key)
        }
      />
    );
  };

  const newclumnsdefs = [
    {
      headerName: "", // No header for row headers
      field: "rowHeader", // Field for row headers
      rowDrag: true,
      // width: 150, // Width of row header column
      // cellRendererFramework: RowHeaderRenderer, // Custom renderer for row headers
      // Optionally, make the row header column unsortable
      sortable: false,
      // Optionally, make the row header column non-editable
      editable: false,
    },

    ...columnDefs,
  ];
  const modifiedColumnDefs = newclumnsdefs.map((column) => {
    if (column.field === "rowHeader") {
      return column;
    } else {
      return {
        ...column,
        cellRendererFramework: CheckboxRenderer,
      };
    }
  });

  const newrowsdata = rowData.map((it, index) => ({
    rowHeader: it?.headerName,
    ...it,
  }));

  const onDragEndMove = async (result) => {
    const { node: data } = result;
    const newdatas = { ...data };
    const { data: rdata, rowIndex } = newdatas;
    const newrowdata = [...rowData];
    const index = newrowdata.findIndex((item) => item.field === rdata.field);
    const [removed] = newrowdata.splice(index, 1);

    newrowdata.splice(rowIndex, 0, removed);
    setRowData(newrowdata);

    const datares = {
      app_token: commonData.commonData().appToken,
      user_uuid: commonData.commonData().userId,
      attribute_set_key: param.attribute_set_key,
      attributes: newrowdata.map((it) => it.field),
    };
    const response = await fetch(`${api}attribute/sequence`, {
      method: "POST",
      body: JSON.stringify(datares),
    });

    const redata = await response.json();
  };

  const listSettings = ["show_on_column", "sortable", "is_filter"];

  const listfilters = modifiedColumnDefs.filter((field) =>
    listSettings.includes(field.field)
  );

  const formcludef = [];
  const listFields = {
    headerName: "List Settings",
    children: listfilters.map((item) => ({
      field: item.field,
      width: 130,
      headerName: item.headerName,
      cellRendererFramework: CheckboxRenderer,
    })),
  };
  formcludef.push(listFields);

  const formSettings = ["show_on_form", "is_required"];

  const formfields = modifiedColumnDefs.filter((field) =>
    formSettings.includes(field.field)
  );

  const formsfield = {
    headerName: "Form Settings",
    children: formfields.map((item) => ({
      field: item.field,
      width: 130,
      headerName: item.headerName,
      cellRendererFramework: CheckboxRenderer,
    })),
  };

  formcludef.push(formsfield);

  const kanabandesirablefield = ["show_in_kanban", "show_group_by"];

  const kanabanfilter = modifiedColumnDefs.filter((field) =>
    kanabandesirablefield.includes(field.field)
  );

  const kanbanfields = {
    headerName: "Kanban Settings",
    children: kanabanfilter.map((item) => ({
      field: item.field,
      width: 130,
      headerName: item.headerName,
      cellRendererFramework: CheckboxRenderer,
    })),
  };
  formcludef.push(kanbanfields);

  const attributedesirablefield = [
    "readonly",
    "show_in_related",
    "is_editable",
    "show_reason",
    "show_in_modal",
    "bulkupdate",
    "published",
    "attribute_status",
  ];

  const attributefilter = modifiedColumnDefs.filter((field) =>
    attributedesirablefield.includes(field.field)
  );

  const attributefields = {
    headerName: "Attribute",
    children: attributefilter.map((item) => ({
      field: item.field,
      width: 130,
      headerName: item.headerName,
      cellRendererFramework: CheckboxRenderer,
    })),
  };
  formcludef.push(attributefields);

  // formcludef.push({ field: "sortable", headerName: "Is Sortable" });
  formcludef.unshift({
    pinned: "left",
    filter: "agTextColumnFilter",
    menuTabs: ["filterMenuTab"],
    headerName: "", // No header for row headers
    field: "rowHeader", // Field for row headers
    rowDrag: true,
    width: 150, // Width of row header column
    // cellRendererFramework: RowHeaderRenderer, // Custom renderer for row headers
    // Optionally, make the row header column unsortable
    sortable: false,
    // Optionally, make the row header column non-editable
    editable: false,
  });

  if (loading) {
    return <Loading />;
  }
  if (attributes.length === 0) {
    return <strong className="mt-5">No Record Found</strong>;
  }

  return (
    <div className={`ag-theme-alpine propertiseAg`}>
      <AgGridReact
        columnDefs={formcludef}
        rowData={newrowsdata}
        rowDragManaged={true}
        onRowDragEnd={onDragEndMove}
        ref={gridRef}
      />
    </div>
  );
};

export default React.memo(AttributePropertiseManagement);
